module.exports = __webpack_public_path__ + "assets/img/4.9e4e55ce.png";